import { setDisplayErrorSnackBar } from "../../features/userSlice";
import store from "../../store";
import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

// function getAllPackages(oauthTokenHeader: any, from_date: any, to_date: any) {
//   return fetchWrapper.get(
//     `${apiUrl}/data_collection/packages/?from=${from_date}&to=${to_date}`,
//     oauthTokenHeader
//   );
// }

function getAllPackages(
   oauthTokenHeader: any,
  from_date: any,
  to_date: any,
  rpp?: any,
  page?: any,
  filters?: {
    status?: string[];
    process_id?: string[]; // Changed from process_name to process_id
    package_name?: string[];
    brand_id?: string[];
    interface_id?: string[];
  }
) {
  const params = new URLSearchParams();

  // Always include date range
  params.append("from", from_date);
  params.append("to", to_date);
   params.append("rpp", rpp);
  params.append("page", page);
  // Add optional filters only if they are non-empty
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value.length > 0) {
        // No need for special processing unless required by backend
        const processValue = (val: string | number) => String(val);

        if (Array.isArray(value)) {
          value.forEach((val) => {
            if (val !== "" && val !== null && val !== undefined) {
              params.append(key, processValue(val));
            }
          });
        } else {
          params.append(key, processValue(value));
        }
      }
    });
  }
    const queryString = params.toString();
  return fetchWrapper.get(
    `${apiUrl}/data_collection/packages/?${queryString}`,
    oauthTokenHeader
  );
}

function getPackageSummeryData(oauthTokenHeader: any, from_date: any, to_date: any) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/package_data_summary/?from=${from_date}&to=${to_date}`,
    oauthTokenHeader
  );
}

function getQueryBizLayerData(oauthTokenHeader: any, query_id: any, website_shared_uid: any, from_date: any, to_date: any) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${query_id}/?website_shared_uid=${website_shared_uid}&start_date=${from_date}&end_date=${to_date}`,
    oauthTokenHeader
  );
}

function getSingleFilter(filter: string, oauthTokenHeader: any) {
  const params = new URLSearchParams();
  params.append("filters", filter);

  return fetchWrapper.get(
    `${apiUrl}/filters/?${params.toString()}`,
    oauthTokenHeader
  );
}

function getAllFilters(filters: string[], oauthTokenHeader: any) {
  const params = new URLSearchParams();
  filters.forEach((filter) => {
    if (filter) {
      params.append("filters", filter);
    }
  });

  return fetchWrapper.get(
    `${apiUrl}/filters/?${params.toString()}`,
    oauthTokenHeader
  );
}

async function getAllFiltersInParallel(filters: string[], oauthTokenHeader: any) {
  try {
    const filterPromises = filters.map((filter) =>
      getSingleFilter(filter.toUpperCase(), oauthTokenHeader)
    );

    const responses = await Promise.allSettled(filterPromises);

    // Combine successful responses
    const combinedData: any = {};

    responses.forEach((result, index) => {
      if (result.status === "fulfilled" && result.value?.status === 200) {
        const filterName = filters[index].toUpperCase();
        combinedData[filterName] = result.value.data?.data?.[filterName] || [];
      } else if (result.status === "rejected") {
        store.dispatch(setDisplayErrorSnackBar({ message: `Failed to fetch filter: ${filters[index]}, ${result.reason}`, type: "error", }));
      }
    });

    return {
      status: 200,
      data: { data: combinedData },
    };
  } catch (error) {
    console.error("Error fetching filters in parallel:", error);
    throw error;
  }
}
export const monitoringPackagesService = {
    getAllPackages,
    getPackageSummeryData,
    getQueryBizLayerData,
    getAllFilters,
    getAllFiltersInParallel
  };